module.exports = __webpack_public_path__ + "static/img/Linearicons-Free.2781bf5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.svg?w118d
// module id = JyLU
// module chunks = 1